module.exports = __webpack_public_path__ + "img/admin-a6.f85320a2.png";